
const YonetimKurulu = () => {
  return (
    <> 
      <div className="row justify-content-center mb-4 header-hero pt-4 pb-4">
        <div className="col-md-10 col-sm-12">
          <h2>Yönetim Kurulu</h2>
        </div>
      </div>

      <div className="row justify-content-md-center yonetim">
        <div className="col-md-8 col-sm-12 mt-4 table-responsive">
          <table className="table table-light table-striped-columns table-bordered table-hover mt-4">
            <tbody>
              <tr>
                <td className="py-3 ps-4">Doç. Dr. Mustafa ÇALIŞKAN</td>
                <td className="py-3 ps-4">Yönetim Kurulu Başkanı</td>
              </tr>
              <tr>
                <td className="py-3 ps-4">Engin DİNÇ</td>
                <td className="py-3 ps-4">Başkan Vekili</td>
              </tr>
              <tr>
                <td className="py-3 ps-4">Seylan DEMİR</td>
                <td className="py-3 ps-4">Yönetim Kurulu Üyesi</td>
              </tr>
              <tr>
                <td className="py-3 ps-4">Mehmet ÇATAL</td>
                <td className="py-3 ps-4">Yönetim Kurulu Üyesi</td>
              </tr>
              <tr>
                <td className="py-3 ps-4">Prof. Dr. Murat BALCI</td>
                <td className="py-3 ps-4">Yönetim Kurulu Üyesi</td>
              </tr>
              <tr>
                <td className="py-3 ps-4">Prof. Dr. Kemalettin AYDIN</td>
                <td className="py-3 ps-4">Yönetim Kurulu Üyesi</td>
              </tr>
              <tr>
                <td className="py-3 ps-4">Turgut ŞENOL</td>
                <td className="py-3 ps-4">Yönetim Kurulu Üyesi ve Genel Müdür</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default YonetimKurulu;
